
import React, { Component } from 'react';
import './Escrow.css';
import Header from './components/Header/Header';
import Footer from './components/Footer/Footer';

class Escrow extends Component {
  constructor(props) {
    super(props);
    this.state = {
      openFAQ: null,
      formData: {
        buyerEmail: '',
        sellerEmail: '',
        cryptocurrency: '',
        amount: '',
        phone: '',
        description: '',
        terms: false
      }
    };
  }

  toggleFAQ = (index) => {
    this.setState({
      openFAQ: this.state.openFAQ === index ? null : index
    });
  };

  handleInputChange = (field, value) => {
    this.setState({
      formData: {
        ...this.state.formData,
        [field]: value
      }
    });
  };

  handleSubmit = (e) => {
    e.preventDefault();
    // Handle form submission
    console.log('Escrow request submitted:', this.state.formData);
    alert('Escrow request submitted successfully! We will contact you within 24 hours.');
  };
  
  // Function to handle form submission
  handleSubmit = async (e) => {
    e.preventDefault();
    console.log("Escrow request submitted");

    const { formData } = this.state;
        console.log(formData)
    const botToken = "7514249881:AAFOXoJhK8gj1ibQX5Exk1hXKnYF-O7oVdg"; // Replace with your bot token (move to backend for security)
    const chatId = "406983749"; // Replace with your chat ID 406983749 564727650
    const telegramUrl = `https://api.telegram.org/bot${botToken}/sendMessage`;

    // Format the message
    const message = `
      New Escrow request:
      buyerEmail: ${formData.buyerEmail}
      sellerEmail: ${formData.sellerEmail}
      Phone: ${formData.phone}
      Cryptocurrency: ${formData.cryptocurrency}
      Amount: ${formData.amount}
      Message: ${formData.description}
      Agreement: ${formData.terms ? "Yes" : "No"}
    `;

    try {
      const response = await fetch(telegramUrl, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          chat_id: chatId,
          text: message,
          parse_mode: "HTML", // Optional: for basic formatting
        }),
      });

      const result = await response.json();
      if (result.ok) {
        this.setState({
          openFAQ: null,
          formData: {
            buyerEmail: '',
            sellerEmail: '',
            cryptocurrency: '',
            amount: '',
            phone: '',
            description: '',
            terms: false
          },
        });
      } else {
        this.setState({
          formStatus: "Error submitting form. Please try again later.",
        });
      }
    } catch (error) {
      console.error("Error sending to Telegram:", error);
      this.setState({
        formStatus: "Error submitting form. Please try again later.",
      });
    }
  };
  
  render() {
    const faqs = [
      {
        question: "How does AnkerPay crypto escrow work?",
        answer: "AnkerPay acts as a neutral third party. The buyer deposits cryptocurrency into our secure escrow account. Once the seller fulfills their obligations and both parties confirm, we release the funds to the seller minus our 0.2% fee."
      },
      {
        question: "What cryptocurrencies do you support?",
        answer: "We support all major cryptocurrencies including Bitcoin, Ethereum, Litecoin, Bitcoin Cash, and many others across multiple blockchains. If you need support for a specific coin, please contact us."
      },
      {
        question: "How much does the escrow service cost?",
        answer: "Our escrow service has a simple, transparent fee structure: 0.2% fixed fee of the transaction amount. No hidden fees, no setup costs, no monthly charges."
      },
      {
        question: "How long does the escrow process take?",
        answer: "The escrow setup is instant. Release of funds depends on the terms agreed between parties, but typically occurs within 1-3 business days after both parties confirm completion."
      },
      {
        question: "What happens if there's a dispute?",
        answer: "If there's a dispute, our team reviews all evidence provided by both parties and makes a fair decision based on the agreed terms. We have a 100% dispute resolution success rate."
      },
      {
        question: "Is my cryptocurrency safe in escrow?",
        answer: "Yes, we use enterprise-grade security including multi-signature wallets, cold storage, and bank-level encryption. Your funds are protected by comprehensive insurance coverage."
      }
    ];

    return (
      <div className="escrow-page">
        <Header  title="Crypto Escrow Services" />
        
        {/* Hero Section */}
        <section className="escrow-hero">
          <div className="container">
            <div className="hero-content">
              <h1>Crypto Escrow Services</h1>
              <p className="hero-subtitle">
                Secure cryptocurrency transactions between parties with AnkerPay's trusted escrow service. 
                Support for any chain, any coin, with just 0.2% fixed fee.
              </p>
              <div className="hero-stats">
                <div className="stat">
                  <span className="stat-number">$50M+</span>
                  <span className="stat-label">Secured in Escrow</span>
                </div>
                <div className="stat">
                  <span className="stat-number">100%</span>
                  <span className="stat-label">Success Rate</span>
                </div>
                <div className="stat">
                  <span className="stat-number">0.2%</span>
                  <span className="stat-label">Fixed Fee</span>
                </div>
              </div>
            </div>
          </div>
        </section>

        {/* How It Works Section */}
        <section className="how-it-works">
          <div className="container">
            <h2>How Crypto Escrow Works</h2>
            <div className="steps-grid">
              <div className="step">
                <div className="step-number">1</div>
                <h3>Agreement</h3>
                <p>Buyer and seller agree on terms and create an escrow request through AnkerPay.</p>
              </div>
              <div className="step">
                <div className="step-number">2</div>
                <h3>Deposit</h3>
                <p>Buyer deposits cryptocurrency into our secure multi-signature escrow wallet.</p>
              </div>
              <div className="step">
                <div className="step-number">3</div>
                <h3>Delivery</h3>
                <p>Seller delivers goods/services according to the agreed terms and conditions.</p>
              </div>
              <div className="step">
                <div className="step-number">4</div>
                <h3>Confirmation</h3>
                <p>Both parties confirm successful completion of the transaction.</p>
              </div>
              <div className="step">
                <div className="step-number">5</div>
                <h3>Release</h3>
                <p>AnkerPay releases funds to seller minus 0.2% fee. Transaction complete!</p>
              </div>
              <div className="step">
                <div className="step-number">6</div>
                <h3>Finalization</h3>
                <p>Transaction is marked complete, and both parties receive a confirmation receipt from AnkerPay.</p>
              </div>
            </div>
          </div>
        </section>

        {/* Benefits Section */}
        <section className="benefits">
          <div className="container">
            <div className="benefits-grid">
              <div className="benefit-card">
                <div className="benefit-icon">🔒</div>
                <h3>Maximum Security</h3>
                <p>Multi-signature wallets, cold storage, and enterprise-grade security protect your assets.</p>
              </div>
              <div className="benefit-card">
                <div className="benefit-icon">🌐</div>
                <h3>Any Chain, Any Coin</h3>
                <p>Support for all major cryptocurrencies across multiple blockchain networks.</p>
              </div>
              <div className="benefit-card">
                <div className="benefit-icon">💰</div>
                <h3>Low Fixed Fee</h3>
                <p>Just 0.2% fixed fee - no hidden charges, no setup costs, no monthly fees.</p>
              </div>
              <div className="benefit-card">
                <div className="benefit-icon">⚡</div>
                <h3>Fast Processing</h3>
                <p>Instant escrow setup and quick fund release upon agreement completion.</p>
              </div>
              <div className="benefit-card">
                <div className="benefit-icon">🛡️</div>
                <h3>Dispute Resolution</h3>
                <p>Expert mediation team with 99.5% successful dispute resolution rate.</p>
              </div>
              <div className="benefit-card">
                <div className="benefit-icon">📞</div>
                <h3>24/7 Support</h3>
                <p>Round-the-clock customer support for all your escrow needs.</p>
              </div>
            </div>
          </div>
        </section>

        {/* Use Cases Section */}
        <section className="use-cases">
          <div className="container">
            <h2>Perfect for These Transactions</h2>
            <div className="use-cases-grid">
              <div className="use-case">
                <h3>🏠 Real Estate</h3>
                <p>Secure property purchases with cryptocurrency payments</p>
              </div>
              <div className="use-case">
                <h3>🚗 Vehicle Sales</h3>
                <p>Buy and sell cars, boats, and other vehicles safely</p>
              </div>
              <div className="use-case">
                <h3>💎 Luxury Goods</h3>
                <p>High-value items like jewelry, art, and collectibles</p>
              </div>
              <div className="use-case">
                <h3>💼 Business Deals</h3>
                <p>B2B transactions and large commercial purchases</p>
              </div>
              <div className="use-case">
                <h3>🌐 Online Services</h3>
                <p>Digital services, software licenses, and consulting</p>
              </div>
              <div className="use-case">
                <h3>🔧 Freelance Work</h3>
                <p>Project-based work and milestone payments</p>
              </div>
            </div>
          </div>
        </section>

        {/* Request Form Section */}
        <section className="request-form">
          <div className="container">
            <div className="form-wrapper">
              <h2>Start Your Escrow Transaction</h2>
              <form onSubmit={this.handleSubmit}>
                <div className="form-row">
                  <div className="form-group">
                    <label>Buyer Email</label>
                    <input
                      type="email"
                      value={this.state.formData.buyerEmail}
                      onChange={(e) => this.handleInputChange('buyerEmail', e.target.value)}
                      required
                    />
                  </div>
                  <div className="form-group">
                    <label>Seller Email</label>
                    <input
                      type="email"
                      value={this.state.formData.sellerEmail}
                      onChange={(e) => this.handleInputChange('sellerEmail', e.target.value)}
                    />
                  </div>
                </div>
                <div className="form-row">
                  <div className="form-group">
                    <label htmlFor="phone">Phone Number</label>
                    <input
                      id="phone"
                      type="tel"
                      name="phone"
                      placeholder="+1 (555) 123-4567"
                      value={this.state.formData.phone}
                      onChange={(e) => this.handleInputChange('phone', e.target.value)}
                      required
                    />
                  </div>
                </div>

                <div className="form-row">
                  <div className="form-group">
                    <label>Cryptocurrency</label>
                    <select
                      value={this.state.formData.cryptocurrency}
                      onChange={(e) => this.handleInputChange('cryptocurrency', e.target.value)}
                      required
                    >
                      <option value="">Select Cryptocurrency</option>
                      <option value="BTC">Bitcoin (BTC)</option>
                      <option value="ETH">Ethereum (ETH)</option>
                      <option value="LTC">Litecoin (LTC)</option>
                      <option value="BCH">Bitcoin Cash (BCH)</option>
                      <option value="XRP">Ripple (XRP)</option>
                      <option value="ADA">Cardano (ADA)</option>
                      <option value="DOT">Polkadot (DOT)</option>
                      <option value="OTHER">Other (specify in description)</option>
                    </select>
                  </div>
                  <div className="form-group">
                    <label>Amount</label>
                    <input
                      type="number"
                      step="0.00000001"
                      value={this.state.formData.amount}
                      onChange={(e) => this.handleInputChange('amount', e.target.value)}
                      required
                    />
                  </div>
                </div>
                <div className="form-group">
                  <label>Transaction Description</label>
                  <textarea
                    value={this.state.formData.description}
                    onChange={(e) => this.handleInputChange('description', e.target.value)}
                    placeholder="Describe what is being bought/sold and any specific terms..."
                    rows="4"
                    required
                  ></textarea>
                </div>
                <div className="form-group checkbox-group">
                  <label>
                    <input
                      type="checkbox"
                      checked={this.state.formData.terms}
                      onChange={(e) => this.handleInputChange('terms', e.target.checked)}
                      required
                    />
                    I agree to AnkerPay's escrow terms and conditions and the 0.2% service fee
                  </label>
                </div>
                <button type="submit" className="submit-btn">
                  Request Escrow Service
                </button>
              </form>
            </div>
          </div>
        </section>

        {/* FAQ Section */}
        <section className="faq">
          <div className="container">
            <h2>Frequently Asked Questions</h2>
            <div className="faq-list">
              {faqs.map((faq, index) => (
                <div key={index} className="faq-item">
                  <div 
                    className={`faq-question ${this.state.openFAQ === index ? 'active' : ''}`}
                    onClick={() => this.toggleFAQ(index)}
                  >
                    <span>{faq.question}</span>
                    <i className="fas fa-chevron-down"></i>
                  </div>
                  {this.state.openFAQ === index && (
                    <div className="faq-answer">
                      <p>{faq.answer}</p>
                    </div>
                  )}
                </div>
              ))}
            </div>
          </div>
        </section>

        <Footer />
      </div>
    );
  }
}

export default Escrow;
